import { PlanyoService } from '@/api'
import date from 'date-and-time'

// state
const state = () => ({
  base: [],
  packages: [],
  byStore: [],
  delivery: [],
  deposit: [],
  productsOrder: [],
  deliveryId: [],
  filterByCountry: true,
  requestObject: {},
})

// getters
const getters = {
  baseProductsFilteredByCountry(state, getters, rootState) {
    if (state.filterByCountry)
      return state.base.filter(
        (v) =>
          v?.properties?.country_availability === rootState.user.shippingCountry ||
          v?.properties?.country_availability === 'ALL'
      )

    return state.base
  },
  withFreeShipment(state, getters, rootState) {
    const output = []
    state.base.forEach((v) => {
      const productInCart = rootState.cart.items.find((cartItem) => cartItem.id === v.id)
      if (!productInCart) return false

      const freeItems =
        (v?.properties?.free_delivery_items_per_quantity_step &&
          v?.properties?.free_delivery_items_per_quantity_step.split(';')) ||
        false
      if (!freeItems) return false
      if (freeItems.length) {
        freeItems.map((item) => {
          const itemArr = item.split(':')

          if (itemArr.length === 2) {
            const itemObj = {
              id: itemArr[0],
              amount: (itemArr[1] * productInCart.quantity) / v.properties.quantity_step,
            }
            output.push(itemObj)
          }
        })
      }
    })

    return output
  },
}

// actions
const actions = {
  async getAll({ state, commit, rootState, rootGetters }, params) {
    const startDate = date.format(rootState.cart.startDate, 'YYYY-MM-DD')
    const endDate = date.format(rootGetters['cart/endDate'], 'YYYY-MM-DD')

    const newRequestObject = {
      ...params,
      start_time: startDate,
      end_time: endDate,
      detail_level: 12,
      language: rootState.user.currentLanguage,
    }

    if (JSON.stringify(newRequestObject) === JSON.stringify(state.requestObject)) {
      return true
    }

    const resp = await PlanyoService.resourceSearch(newRequestObject)

    const products = Object.values(resp.resources.data.results)
    const productsOrder = resp.order
    const deliveryId = resp.delivery[rootState.user.shippingCountry.toLowerCase()]
    const depositId = resp.deposit[rootState.user.shippingCountry.toLowerCase()]

    const base = products
      .filter((v) => !Object.prototype.hasOwnProperty.call(v.properties, 'hidden_is_package'))
      .filter((v) => v.properties.show_product !== 'no')

    const deliveryProducts = products.filter((v) => Object.values(deliveryId).includes(v.id))
    const depositProduct = [{ ...products.find((v) => v.id == depositId), quantity: 1 }]

    const packages = products.filter((v) => Object.prototype.hasOwnProperty.call(v.properties, 'hidden_is_package'))

    const byStore = []
    packages.forEach((item) => {
      const store = byStore.find((v) => v.name === item.properties.storage_name)
      if (!store) {
        const st = {
          name: item.properties.storage_name,
          items: [item],
        }
        byStore.push(st)
      } else {
        store.items.push(item)
      }
    })

    commit('setRequestObject', newRequestObject)
    commit('setBaseProducts', base)
    commit('setDeliveryProducts', deliveryProducts)
    commit('setDepositProducts', depositProduct)
    commit('setPackagesProducts', packages)
    commit('setByStoreProducts', byStore)
    commit('setProductsOrder', productsOrder)
    commit('setDeliveryId', deliveryId)
    commit('cart/clearCart', null, { root: true })
  },
}

// mutations
const mutations = {
  setRequestObject(state, object) {
    state.requestObject = object
  },
  setBaseProducts(state, products) {
    state.base = products
  },
  setDeliveryProducts(state, products) {
    state.delivery = products
  },
  setDepositProducts(state, products) {
    state.deposit = products
  },
  setPackagesProducts(state, products) {
    state.packages = products
  },
  setByStoreProducts(state, products) {
    state.byStore = products
  },
  setProductsOrder(state, productsOrder) {
    state.productsOrder = productsOrder
  },
  setDeliveryId(state, deliveryId) {
    state.deliveryId = deliveryId
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
